const navList = document.querySelector('.main-nav__list');
let linkShift;
let target;
window.offset = null;

const moveTo = new MoveTo({
  duration: 800,
  easing: 'easeOutQuart',
});

const scrollToLink = () => {
  if (navList) {
    const links = navList.querySelectorAll('a');
    if (links) {
      links.forEach((el) => {
        el.addEventListener('click', () => {
          if (el.dataset.href) {
            target = document.getElementById(el.dataset.href);
            moveTo.move(target);
          }
        });
      });
    }
  }
}


export {scrollToLink};
